import { isEmpty } from "@s-libs/micro-dash";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestQuery from "@/remoteState/useRestQuery";

const buildParamsString = (params) => {
  return isEmpty(params) ? "" : `?${new URLSearchParams(params).toString()}`;
};

const useTeacherSchoolGet = (id, params = null, skip = false) => {
  const paramStrings = buildParamsString(params);
  return useRestQuery(
    `${MONOLITH_ORIGIN}/api/v3/user/${id}/teacher/school/${paramStrings}`,
    { skip: !id || skip },
  );
};

export default useTeacherSchoolGet;
